export class NetworkMonitor {
    private listeners: ((isOnline: boolean) => void) | null = null;
    private isOnline = navigator.onLine;

    constructor() {
        window.addEventListener('online', () => this.setOnlineStatus(true));
        window.addEventListener('offline', () => this.setOnlineStatus(false));
    }

    /**
     * Get current online status
     */
    getStatus(): boolean {
        return this.isOnline;
    }

    /**
     * Add a listener for online status changes
     */
    addListener(listener: (isOnline: boolean) => void) {
        this.listeners = listener;
    }

    /**
     * Remove listener
     */
    removeListener() {
        this.listeners = null;
    }

    /**
     * Check if should fetch today (only once per day)
     */
    shouldFetchToday(): boolean {
        const today = new Date().toDateString();
        const lastFetch = sessionStorage.getItem('lastConfigFetch');

        if (lastFetch !== today) {
            return true;
        }

        return false;
    }

    private setOnlineStatus(isOnline: boolean) {
        if (this.isOnline !== isOnline) {
            this.isOnline = isOnline;
            if (this.listeners) {
                this.listeners(isOnline);
            }
        }
    }
}

export const networkMonitor = new NetworkMonitor();
